/* eslint-disable */
import fetch_countries from "@/apollo/destinations/countries_list.gql";
import package_cities from "@/apollo/destinations/pkg_cities.gql";
import cruise_countries from "@/apollo/destinations/cruise_country.gql";
import listing from "@/apollo/destinations/listing.gql";

export const state = () => ({
  listing: [],
  type_listing: {},
  loading: false,
  country_list: [],
  countries_loading: false,
  pkg_destinations: [],
  cruises: []
});

export const mutations = {
  setCountriesListing: (state, value) => (state.country_list = value),
  setCountriesLoading: (state, value) => (state.countries_loading = value),
  setPkgDestination: (state, value) => (state.pkg_destinations = value),
  setCruiseDestination: (state, value) => (state.cruises = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Oct 2024 | 10:58AM
   * @param {*} state
   * @param {*} { value, type }
   */
  SET_LISTING(state, { value, type }) {
    if (type) state.type_listing[type] = value;
    else state.listing = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Oct 2024 | 10:59AM
   * @param {*} state
   * @param {*} value
   */
  SET_LISTING_LOADING: (state, value) => (state.loading = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Oct 2024 | 11:00AM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  fetchListing({ commit }, payload) {
    commit("SET_LISTING_LOADING", true);
    commit("SET_LISTING", { value: [], type: payload?.type });
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { ...payload } })
        .then(({ data }) => {
          commit("SET_LISTING", { value: data?.getDestinations || [], type: payload?.type });
          resolve(data.getDestinations);
          commit("SET_LISTING_LOADING", false);
        })
        .catch((err) => {
          commit("SET_LISTING_LOADING", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 10 Aug 2023 | 05:14PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchCountriesListing({ commit }) {
    commit("setCountriesLoading", true);
    commit("setCountriesListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: fetch_countries })
        .then(({ data }) => {
          commit("setCountriesListing", data.fetch_countries);
          resolve(data.fetch_countries);
          commit("setCountriesLoading", false);
        })
        .catch((err) => {
          commit("setCountriesLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 19 Apr 2024 | 12:40PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchPkgDestinations({ commit }) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: package_cities }).then(({ data }) => {
        commit("setPkgDestination", data.pkg_destinations_cities);
        resolve(data.pkg_destinations_cities);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Jan 2025 | 03:36PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchCruiseDestinations({ commit }) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: cruise_countries }).then(({ data }) => {
        commit("setCruiseDestination", data.cruise_destinations);
        resolve(data.cruise_destinations);
      });
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  type_listing: (state) => state.type_listing,
  loading: (state) => state.loading,
  country_list: (state) => state.country_list,
  countries_loading: (state) => state.countries_loading,
  pkg_destinations: (state) => state.pkg_destinations,
  cruises: (state) => state.cruises
};
